// splitDateOfBirth :: String -> {}
export const splitDateOfBirth = (dateOfBirth): any => {
  if (!dateOfBirth) return {}
  const [year, month, day] = dateOfBirth.split('-')

  return {
    year,
    month,
    day,
  }
}
